// umlaut-check: skip — "erklaerung" ist ein Objektschlüssel (technischer
// Bezeichner), die sichtbaren Texte selbst tragen Umlaute korrekt.

import React, {useMemo} from "react";

const STUFEN = [
    {schluessel: "ist", label: "Ist", farbe: "#212529", erklaerung: "Tatsächlich gemessener Bestand oder Buchung, kein Rechenwert."},
    {schluessel: "gemessen", label: "Gemessen", farbe: "#0d6efd", erklaerung: "Aus der eigenen Historie errechnet, wächst mit jedem Tag Daten."},
    {schluessel: "aus_datei", label: "Aus Datei", farbe: "#6c757d", erklaerung: "Aus Oskars Datei oder der Ampel-Datei übernommen."},
    {schluessel: "angenommen", label: "Angenommen", farbe: "#e8a400", erklaerung: "Begründete Annahme, solange die Messung noch fehlt – im Bereich sichtbar, nicht im Programmcode versteckt."},
    {schluessel: "gepflegt", label: "Gepflegt", farbe: "#20c997", erklaerung: "Von Hand eingetragen, mit Begründung und Person."},
];

function einstellungWert(einstellungen, schluessel) {
    return (einstellungen || []).find((e) => e.schluessel === schluessel) || null;
}

/**
 * Übersicht "Wie sicher sind die Zahlen?" (Folie 8, Auftrag S7): die fünf
 * Sicherheitsstufen als Legende, dazu zwei angenommene Annahmen live aus
 * cosmos_einstellungen gegen die tatsächlich gemessene Cosmos-Termintreue
 * aus der Mail-Recherche vom 22.09.2026 gehalten.
 */
export default function SicherheitsstufenUebersicht({einstellungen}) {
    const wiederbeschaffung = useMemo(() => einstellungWert(einstellungen, "wiederbeschaffung_tage"), [einstellungen]);
    const lieferrhythmus = useMemo(() => einstellungWert(einstellungen, "lieferrhythmus_wochen"), [einstellungen]);

    return (
        <div>
            <div className="d-flex flex-wrap gap-3 mb-3">
                {STUFEN.map((s) => (
                    <div key={s.schluessel} className="d-flex align-items-start gap-2" style={{maxWidth: 220}}>
                        <span className="badge" style={{backgroundColor: s.farbe, marginTop: 2}}>
                            {s.label}
                        </span>
                        <span className="small text-muted">{s.erklaerung}</span>
                    </div>
                ))}
            </div>

            <div className="border rounded-2 p-3 bg-body-secondary">
                <div className="fw-semibold small mb-2">Zwei angenommene Annahmen im Abgleich mit der gemessenen Wirklichkeit</div>
                <div className="row g-3 small">
                    <div className="col-md-6">
                        <div className="text-muted">Wiederbeschaffungszeit (angenommen)</div>
                        <div className="fw-semibold">
                            {wiederbeschaffung ? `${wiederbeschaffung.anzeige_wert ?? wiederbeschaffung.wert}` : "–"}
                        </div>
                        <div className="text-muted">Gemessener Transport Weilheim (Median, n = 18 LKW): 7 Tage</div>
                    </div>
                    <div className="col-md-6">
                        <div className="text-muted">Lieferrhythmus (angenommen)</div>
                        <div className="fw-semibold">{lieferrhythmus ? `${lieferrhythmus.anzeige_wert ?? lieferrhythmus.wert}` : "–"}</div>
                        <div className="text-muted">Gemessene Termintreue Cosmos zur Zusage (n = 18 LKW): 13 pünktlich, Mittel +0,3 Wochen</div>
                    </div>
                </div>
                <div className="small text-muted mt-2 fst-italic">
                    Quelle der gemessenen Werte: Mail- und Lieferschein-Recherche vom 22.09.2026. Die angenommenen Werte
                    stehen unter „Alle Quellen im Detail“ weiter unten und lassen sich dort mit Begründung ändern.
                </div>
            </div>
        </div>
    );
}
